import { FEATURE_ROUTE_NAME } from '@/libs/route-name';

export const featureRoute = () => {
    return {
        name: FEATURE_ROUTE_NAME.FEATURE,
        path: 'feature',
        component: () => import('@/pages/feature/index.vue'),
    };
};
